import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import InstitutionTranscriptCourseStatusService from "../../src/Services/InstitutionTranscriptCourseStatus.service";
import LookupGeneric from "./lookupGeneric";
const InstitutionTranscriptCourseStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<InstitutionTranscriptCourseStatus[]>' is not assignable to type '(ids: string[]) => Promise<InstitutionTranscriptCourseStatus[]>'.
        fetchItemsById: (ids) => {
            return InstitutionTranscriptCourseStatusService.findByIds(ids).then(({ data }) => data);
        },
        fetchOptions: (name) => {
            return InstitutionTranscriptCourseStatusService.search({
                name,
                active: true,
            }).then(({ data }) => data);
        },
        optionRenderer: function optionRenderer(institutionTranscriptCourseStatus) {
            return _jsx("span", { children: institutionTranscriptCourseStatus.name });
        },
    });
};
export default InstitutionTranscriptCourseStatusLookup;
